// Helpers to forward a DOM scroll event of the web list (react-virtuoso) to an
// optional React Native style `onScroll` handler. Kept free of React / RN imports
// so it can be unit tested with plain node (see web-scroll.test.mjs).

export type WebScrollEvent = { nativeEvent: { contentOffset: { x: number; y: number } } };
export type WebScrollHandler = (event: WebScrollEvent) => void;

export function toNativeScrollEvent(offsetY: number): WebScrollEvent {
  return { nativeEvent: { contentOffset: { y: offsetY, x: 0 } } };
}

// forwardWebScroll schedules a call to the current scroll handler. Not every list
// passes a scrollHandler (e.g. the categories on /app/boodschappen-doen), so the
// handler is looked up lazily and skipped when it is missing — calling it blindly
// threw "b is not a function" (Sentry WEBAPP-3/E/Q).
export function forwardWebScroll(
  getHandler: () => WebScrollHandler | undefined | null,
  offsetY: number,
  schedule: (fn: () => void) => void
): boolean {
  if (typeof getHandler() !== "function") {
    return false;
  }
  schedule(() => {
    const handler = getHandler();
    if (typeof handler === "function") {
      handler(toNativeScrollEvent(offsetY));
    }
  });
  return true;
}
